// @ts-nocheck
/* KidCollective Cart Drawer */
(function(){
  function openCart(skipRefresh){ 
    document.getElementById('kc-cart-drawer')?.classList.add('open'); 
    document.getElementById('kc-cart-overlay')?.classList.add('open'); 
    document.body.style.overflow='hidden'; 
    if(!skipRefresh) refreshCart(); 
  }
  function closeCart(){ 
    document.getElementById('kc-cart-drawer')?.classList.remove('open'); 
    document.getElementById('kc-cart-overlay')?.classList.remove('open'); 
    document.body.style.overflow=''; 
  }

  document.getElementById('kc-cart-toggle')?.addEventListener('click', () => openCart());
  document.getElementById('kc-cart-close')?.addEventListener('click', closeCart);
  document.getElementById('kc-cart-overlay')?.addEventListener('click', closeCart);

  function refreshCart(){
    fetch('/cart.js').then(r=>r.json()).then(cart => {
      updateCartCount(cart.item_count);
      renderCartItems(cart);
    });
  }

  function updateCartCount(count){
    document.querySelectorAll('.kc-cart-count').forEach(el => {
      el.textContent = count;
      if (el.style) el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  window.kcProductCache = window.kcProductCache || {};

  function renderCartItems(cart){
    const container = document.getElementById('kc-cart-items');
    const empty = document.getElementById('kc-cart-empty');
    const footer = document.getElementById('kc-cart-footer');
    const subtotal = document.getElementById('kc-cart-subtotal-amount');
    if(!container) return;

    if(cart.items.length === 0){
      container.querySelectorAll('.kc-cart-item').forEach(el => el.remove());
      if(empty) empty.style.display = '';
      if(footer) footer.style.display = 'none';
      return;
    }

    const missingHandles = cart.items.map(i => i.handle).filter(h => !window.kcProductCache[h]);
    const uniqueMissing = [...new Set(missingHandles)];
    
    Promise.all(uniqueMissing.map(h => fetch('/products/' + h + '.js').then(r=>r.json()).then(p => { window.kcProductCache[h] = p; }).catch(e=>console.error(e))))
    .then(() => {
      container.querySelectorAll('.kc-cart-item').forEach(el => el.remove());
      
      if(empty) empty.style.display = 'none';
      if(footer) footer.style.display = '';
      if(subtotal) subtotal.textContent = formatMoney(cart.total_price);

      let totalSavings = 0;

      cart.items.forEach(item => {
        const div = document.createElement('div');
        div.className = 'kc-cart-item';
        
        let priceHtml = '<p class="kc-cart-item-price">' + formatMoney(item.final_line_price) + '</p>';
        const product = window.kcProductCache[item.handle];
        if (product) {
           const variant = product.variants.find(v => v.id === item.variant_id);
           if (variant && variant.compare_at_price > variant.price) {
               const unitMrp = variant.compare_at_price;
               const lineMrp = unitMrp * item.quantity;
               const linePrice = item.final_line_price;
               const discountPercent = Math.round(((lineMrp - linePrice) / lineMrp) * 100);
               totalSavings += (lineMrp - linePrice);
               
               priceHtml = '<p class="kc-cart-item-price" style="display:flex; align-items:center; gap:6px; flex-wrap:wrap;">' +
                 '<span class="kc-cart-price-final" style="font-weight:600;">' + formatMoney(linePrice) + '</span>' +
                 '<s class="kc-cart-price-mrp" style="color:#888; font-size:0.85em;">' + formatMoney(lineMrp) + '</s>' +
                 '<span class="kc-cart-price-discount" style="color:var(--kc-primary, #e75480); font-size:0.8em; font-weight:600;">(-' + discountPercent + '%)</span>' +
                 '</p>';
           }
        }

        let variantHtml = '';
        if (item.variant_title && item.variant_title !== 'Default Title' && item.variant_title !== 'Default') {
            variantHtml = '<p class="kc-cart-item-variant" style="font-size: 0.85em; color: #666; margin: 4px 0;">' + item.variant_title + '</p>';
        }

        div.innerHTML = '<div class="kc-cart-item-img"><img src="' + getSizedImageUrl(item.image, '200x') + '" alt="' + item.title + '" width="80" height="100"></div>' +
          '<div class="kc-cart-item-info"><p class="kc-cart-item-name" style="font-weight:500;">' + item.product_title + '</p>' +
          variantHtml +
          '<div class="kc-cart-item-price-wrapper" style="margin-top: 4px;">' + priceHtml + '</div>' +
          '<div style="display:flex; justify-content:space-between; align-items:center; margin-top: 12px;">' +
          '<div class="kc-cart-item-qty"><button data-key="' + item.key + '" data-qty="' + (item.quantity-1) + '">−</button><span>' + item.quantity + '</span><button data-key="' + item.key + '" data-qty="' + (item.quantity+1) + '">+</button></div>' +
          '<button class="kc-cart-item-remove" data-key="' + item.key + '" aria-label="Remove item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg></button></div></div>';
        
        container.appendChild(div);

        div.querySelectorAll('.kc-cart-item-qty button').forEach(btn => {
          btn.addEventListener('click', function(){ changeQty(this.dataset.key, +this.dataset.qty, this); });
        });
        const removeBtn = div.querySelector('.kc-cart-item-remove');
        if (removeBtn) {
            removeBtn.addEventListener('click', function(){ changeQty(this.dataset.key, 0, this); });
        }
      });

      const savingsContainer = document.getElementById('kc-cart-savings');
      const savingsAmount = document.getElementById('kc-cart-savings-amount');
      if (savingsContainer && savingsAmount) {
        if (totalSavings > 0) {
          savingsAmount.textContent = formatMoney(totalSavings);
          savingsContainer.style.display = 'block';
        } else {
          savingsContainer.style.display = 'none';
        }
      }
    });
  }

  function changeQty(key, qty, btn){
    // Optimistic UI updates
    if (qty === 0 && btn) {
      const itemEl = btn.closest('.kc-cart-item');
      if (itemEl) itemEl.style.display = 'none'; // hide instantly
    } else if (btn) {
      const qtySpan = btn.parentElement.querySelector('span');
      if(qtySpan) qtySpan.textContent = qty;
    }
    const container = document.getElementById('kc-cart-items');
    if(container) container.style.opacity = '0.6';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({id: key, quantity: qty})
    }).then(r=>r.json()).then(cart => { 
      if(container) container.style.opacity = '1';
      renderCartItems(cart); 
      updateCartCount(cart.item_count); 
    });
  }

  function formatMoney(cents){
    return '₹ ' + (cents/100).toFixed(2);
  }

  function getSizedImageUrl(url, size){
    if(!url) return '';
    const match = url.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
    if(match){
      const prefix = url.split(match[0]);
      return prefix[0] + '_' + size + '.' + match[1] + (match[2] || '');
    }
    return url;
  }

  window.kcAddToCart = function(variantId, qty, btn){
    if(btn) btn.classList.add('loading');
    
    // Open immediately!
    openCart(true);
    const container = document.getElementById('kc-cart-items');
    
    // Optimistic UI: Inject a temporary loading item based on what they clicked
    if (container) {
      let titleStr = "Updating cart...";
      let priceStr = "";
      let imgSrc = "";
      if (btn) {
        const card = btn.closest('.kc-product-card-ui, .kc-wishlist-item, .kc-product-layout, .product-wrapper, .product-single__meta, main');
        if (card) {
          const titleEl = card.querySelector('.kc-product-title, .kc-wishlist-item-name, h1');
          if (titleEl) titleStr = titleEl.textContent.trim();
          const priceEl = card.querySelector('.kc-card-price, .kc-product-price, .kc-wishlist-item-price, .price, .price-item');
          if (priceEl) priceStr = priceEl.innerHTML;
          const imgEl = card.querySelector('img');
          if (imgEl) imgSrc = imgEl.src;
        }
      }
      
      const empty = document.getElementById('kc-cart-empty');
      if(empty) empty.style.display = 'none';
      const footer = document.getElementById('kc-cart-footer');
      if(footer) footer.style.display = '';

      const tempDiv = document.createElement('div');
      tempDiv.className = 'kc-cart-item kc-optimistic-item';
      tempDiv.style.opacity = '0.5';
      tempDiv.style.pointerEvents = 'none';
      tempDiv.style.animation = 'pulse 1.5s infinite';
      tempDiv.innerHTML = '<div class="kc-cart-item-img">' + (imgSrc ? '<img src="'+imgSrc+'" width="80" height="100" style="object-fit:cover">' : '<div style="width:100%;height:100%;background:#f0f0f0"></div>') + '</div>' +
        '<div class="kc-cart-item-info"><p class="kc-cart-item-name">' + titleStr + '</p>' +
        '<p class="kc-cart-item-price">' + priceStr + '</p>' +
        '<div style="font-size:12px; color:var(--kc-teal); margin-top:8px; font-weight:600;">Adding to cart...</div></div>';
      
      container.prepend(tempDiv);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({items:[{id: +variantId, quantity: qty || 1}]})
    })
    .then(r=>r.json())
    .then(() => fetch('/cart.js'))
    .then(r=>r.json())
    .then(cart => { 
      updateCartCount(cart.item_count);
      renderCartItems(cart);
      if(btn) btn.classList.remove('loading');
    });
  };

  window.kcCart = { open: openCart, close: closeCart, refresh: refreshCart };
})();
